const chunkMapping = {
	"1": [
		5515,
		5333,
		3152,
		1452,
		6941,
		1271,
		15,
		2653,
		3177
	],
	"4": [
		5004
	],
	"11": [
		2011
	],
	"21": [
		4021
	],
	"31": [
		31
	],
	"35": [
		8035
	],
	"47": [
		9047
	],
	"83": [
		83
	],
	"104": [
		104
	],
	"115": [
		115
	],
	"129": [
		6129
	],
	"147": [
		7147
	],
	"161": [
		8161
	],
	"194": [
		2194
	],
	"210": [
		1210
	],
	"216": [
		216
	],
	"219": [
		3219
	],
	"222": [
		4222
	],
	"263": [
		3263
	],
	"278": [
		3278
	],
	"308": [
		4308
	],
	"420": [
		8420
	],
	"465": [
		7465
	],
	"507": [
		9507
	],
	"510": [
		4510
	],
	"578": [
		1578
	],
	"580": [
		2580
	],
	"595": [
		7595
	],
	"646": [
		9646
	],
	"653": [
		5034
	],
	"699": [
		5699
	],
	"700": [
		3700
	],
	"701": [
		6701
	],
	"721": [
		4721
	],
	"863": [
		863
	],
	"915": [
		6915
	],
	"919": [
		9919
	],
	"926": [
		2926
	],
	"958": [
		6958
	],
	"988": [
		3988
	],
	"991": [
		4991
	]
};
const idToExternalAndNameMapping = {
	"15": [
		"default",
		"./store",
		1497
	],
	"31": [
		"default",
		"./Provider",
		4141
	],
	"83": [
		"default",
		"./InsurancesAdmin",
		9985
	],
	"104": [
		"default",
		"./ConfirmationForm",
		9985
	],
	"115": [
		"default",
		"./BillingAdmin",
		9985
	],
	"216": [
		"default",
		"./UsersAdmin",
		9985
	],
	"863": [
		"default",
		"./LegacyPoliciesMigrationAdmin",
		9985
	],
	"1210": [
		"default",
		"./ReportsSummaries",
		9985
	],
	"1271": [
		"default",
		"./fnxUtils",
		1497
	],
	"1452": [
		"default",
		"./LocalStorage",
		1497
	],
	"1578": [
		"default",
		"./CollectAdmin",
		9985
	],
	"2011": [
		"default",
		"./PropertiesAdmin",
		9985
	],
	"2194": [
		"default",
		"./CobranzaAdmin",
		9985
	],
	"2580": [
		"default",
		"./Completed",
		9985
	],
	"2653": [
		"default",
		"./WorkflowApp",
		8972
	],
	"2926": [
		"default",
		"./CalculatePremium",
		9985
	],
	"3152": [
		"default",
		"./Loading",
		1497
	],
	"3177": [
		"default",
		"./WorkflowCreateApp",
		8972
	],
	"3219": [
		"default",
		"./CustomReportPage",
		9985
	],
	"3263": [
		"default",
		"./AccountTypeAdmin",
		9985
	],
	"3278": [
		"default",
		"./BranchesAdmin",
		9985
	],
	"3700": [
		"default",
		"./InsuranceTypeAdmin",
		9985
	],
	"3988": [
		"default",
		"./CataloguesAdmin",
		9985
	],
	"4021": [
		"default",
		"./RejectionCodesAdmin",
		9985
	],
	"4222": [
		"default",
		"./RegionAdmin",
		9985
	],
	"4308": [
		"default",
		"./ControlCenterAdmin",
		9985
	],
	"4510": [
		"default",
		"./PaymentConfirmation",
		9985
	],
	"4721": [
		"default",
		"./PassengerForm",
		9985
	],
	"4991": [
		"default",
		"./Clients",
		9985
	],
	"5004": [
		"default",
		"./AddBusiness",
		9985
	],
	"5034": [
		"default",
		"./RolAdmin",
		9985
	],
	"5333": [
		"default",
		"./FormsApp",
		5836
	],
	"5515": [
		"default",
		"./FlowApp",
		9120
	],
	"5699": [
		"default",
		"./InsurancePoliciesSummary",
		9985
	],
	"6129": [
		"default",
		"./PermissionAdmin",
		9985
	],
	"6701": [
		"default",
		"./ProjectTypeAdmin",
		9985
	],
	"6915": [
		"default",
		"./ClientRecord",
		9985
	],
	"6941": [
		"default",
		"./NotFound",
		1497
	],
	"6958": [
		"default",
		"./CustomerForms",
		9985
	],
	"7147": [
		"default",
		"./MasterApp",
		500
	],
	"7465": [
		"default",
		"./PlanAdmin",
		9985
	],
	"7595": [
		"default",
		"./InitialInfo",
		9985
	],
	"8035": [
		"default",
		"./AuditPage",
		9985
	],
	"8161": [
		"default",
		"./ProductCreation",
		9985
	],
	"8420": [
		"default",
		"./Plan",
		9985
	],
	"9047": [
		"default",
		"./authApp",
		4141
	],
	"9507": [
		"default",
		"./PaymentSummary",
		9985
	],
	"9646": [
		"default",
		"./PlanDetails",
		9985
	],
	"9919": [
		"default",
		"./PlanCreation",
		9985
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}